module.exports = __webpack_public_path__ + "36dcc70fdebf1b3e8feae91131cf23ca.svg";